var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { alpha } from '@mui/material/styles';
import { listClasses } from '@mui/material/List';
import { paperClasses } from '@mui/material/Paper';
import { buttonClasses } from '@mui/material/Button';
import { listItemIconClasses } from '@mui/material/ListItemIcon';
import { tablePaginationClasses } from '@mui/material/TablePagination';
//
import { paper } from '../../css';
// ----------------------------------------------------------------------
export function dataGrid(theme) {
    var _a, _b, _c, _d, _e;
    var paperStyles = paper({ theme: theme, dropdown: true });
    return {
        MuiDataGrid: {
            styleOverrides: {
                root: (_a = {
                        '& .MuiDataGrid-scrollbar': {
                            zIndex: 0
                        },
                        '& .MuiDataGrid-row': {
                            cursor: 'pointer'
                        },
                        borderRadius: 0,
                        borderWidth: 0
                    },
                    _a["& .".concat(tablePaginationClasses.root)] = {
                        borderTop: 0
                    },
                    _a["& .".concat(tablePaginationClasses.toolbar)] = {
                        height: 'auto'
                    },
                    _a['& .MuiDataGrid-cell:focus'] = {
                        outline: 'none'
                    },
                    _a['& .MuiDataGrid-cell:focus-within'] = {
                        outline: 'none'
                    },
                    _a['& .MuiDataGrid-columnHeader .MuiDataGrid-sortButton'] = {
                        backgroundColor: 'transparent'
                    },
                    _a),
                cell: {
                    borderBottom: "1px dashed ".concat(theme.palette.divider)
                },
                selectedRowCount: {
                    whiteSpace: 'nowrap'
                },
                columnSeparator: {
                    color: theme.palette.divider
                },
                toolbarContainer: {
                    padding: theme.spacing(2),
                    borderBottom: "1px dashed ".concat(theme.palette.divider),
                    backgroundColor: theme.palette.background.neutral
                },
                paper: __assign(__assign({}, paperStyles), { padding: 0 }),
                menu: (_b = {},
                    _b["& .".concat(paperClasses.root)] = __assign({}, paperStyles),
                    _b["& .".concat(listClasses.root)] = (_c = {
                            padding: 0
                        },
                        _c["& .".concat(listItemIconClasses.root)] = {
                            minWidth: 0,
                            marginRight: theme.spacing(2)
                        },
                        _c),
                    _b),
                columnHeaders: {
                    borderRadius: 0,
                    backgroundColor: theme.palette.background.neutral
                },
                panelHeader: {
                    padding: theme.spacing(2)
                },
                panelFooter: (_d = {
                        padding: theme.spacing(2),
                        justifyContent: 'flex-end',
                        borderTop: "dashed 1px ".concat(theme.palette.divider)
                    },
                    _d["& .".concat(buttonClasses.root)] = {
                        '&:first-of-type': {
                            border: "solid 1px ".concat(alpha(theme.palette.grey[500], 0.24))
                        },
                        '&:last-of-type': {
                            marginLeft: theme.spacing(1.5),
                            color: theme.palette.background.paper,
                            backgroundColor: theme.palette.text.primary
                        }
                    },
                    _d),
                filterForm: (_e = {
                        padding: theme.spacing(2)
                    },
                    _e[theme.breakpoints.only('xs')] = {
                        flexDirection: 'column',
                        gap: '11px'
                    },
                    _e),
                filterFormValueInput: {
                    marginLeft: theme.spacing(2)
                },
                filterFormColumnInput: {
                    marginLeft: theme.spacing(2)
                },
                filterFormDeleteIcon: {
                    marginTop: '13px',
                    alignItems: 'center',
                    justifyContent: 'flex-start'
                },
                filterFormOperatorInput: {
                    marginLeft: theme.spacing(2)
                }
            }
        }
    };
}
